"use client";

import { cn, sectionBackgroundColors, spacingClasses, spacingClassesHero } from "@/lib/utils";
import React from "react";
import { SpacingType, sectionVariants } from "@/types";

interface SectionWrapperProps {
  children?: React.ReactNode;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  spacing?: SpacingType;
  variant?: sectionVariants;
  darkMode?: boolean;
  heroSection?: boolean;
  componentName?: string;
  className?: string;
  attributes?: React.HTMLProps<HTMLElement>;
  removePaddingTop?: boolean;
  removePaddingBottom?: boolean;
  style?: React.CSSProperties;
}

export const SectionWrapper = ({ 
    children,
    usedInPageNav,
    pageNavTitle,
    themeChangeOnScroll,
    spacing,
    variant,
    darkMode,
    heroSection,
    componentName,
    className,
    attributes,
    removePaddingTop,
    removePaddingBottom,
    style
}: SectionWrapperProps) => {
  const { key, ...rest } = attributes ?? {};
  const sectionId = `${componentName}-${key}`;
  const spacingClass = heroSection ? spacingClassesHero[spacing || 'none'] : spacingClasses[spacing || 'none'];

  const sectionClass = cn(
    spacingClass,
    darkMode ? 'dark' : 'light',
    sectionBackgroundColors(darkMode || false, variant || "A"),
    removePaddingTop ? "!pt-0" : "",
    removePaddingBottom ? "!pb-0" : "",
    "text-foreground content-section",
    className,
  );

  return (
    <section 
      {...rest}
      className={sectionClass}
      id={sectionId}
      data-page-nav={usedInPageNav}
      data-page-nav-title={pageNavTitle}
      data-trackable-section={sectionId}
      {...(themeChangeOnScroll && {
        "data-theme-change": "dark"
      })}
      style={style}
      suppressHydrationWarning
    >
      {children}
    </section>
  );
};